<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>生产单元数据</el-breadcrumb-item>
      <el-breadcrumb-item>智能仓储电机统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div>
        <h3>请选择查询条件：</h3>
        <el-form :model="inquireList" ref="addFormRef" label-width="80px" class="form">
          <div class="from01">
            <div>
              <el-form-item label="变量" prop="TypeName">
                <el-select v-model="inquireList.number01" placeholder="请选择变量" clearable>
                  <el-option v-for="item in ordersList" :key="item.ID" :label="item.VariableName" :value="item.ID">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="bytn01">
              <el-button type="primary" @click="getNumber()">查 询</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="echart01">
        <div ref="chart" style="width: 100%; height: 400%"></div>
      </div>
    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '100',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_variable_maintenance'
            },
            // 订单信息列表
            ordersList: [],
            // 查询所需
            inquireList: {
                number01: '',
                number02: ''
            },
            ID: ''
        }
    },
    created () {
        this.getOrderList()
    },
    mounted () {
        this.timer = setInterval(() => {
            this.getNumber()
        }, 2000)
        this.$once('hook:beforeDestroy', () => {
            clearInterval(timer);
        })
        this.init()

    },
    beforeDestroy () {
        clearInterval(this.timer);
        this.timer = null;
    },
    methods: {
        init (number) {
            const myChart = echarts.init(this.$refs.chart)
            var number01 = []
            var number02 = []
            if (number.length > 0) {
                for (let i = 0; i < number.length; i++) {
                    number01.push(number[i].CreateTimeConvert)
                    number02.push(number[i].Value)
                }
            }
            const option = {
                xAxis: {
                    type: 'category',
                    data: number01
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: number02,
                        type: 'line'
                    }
                ],
                tooltip: { // 鼠标悬浮提示框显示 X和Y 轴数据
                    trigger: 'axis',
                    backgroundColor: 'rgba(32, 33, 36,.7)',
                    borderColor: 'rgba(32, 33, 36,0.20)',
                    borderWidth: 1,
                    textStyle: { // 文字提示样式
                        color: '#fff',
                        fontSize: '12'
                    },
                }
            }
            myChart.setOption(option)
        },
        // 调用接口获取变量维护表
        async getOrderList () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList })
            console.log(res.data)
            this.ordersList = res.data
        },
        // 调用接口获取图表数据
        async getNumber () {
            let params = new URLSearchParams();
            // if (!this.inquireList.number01) return this.$message.error('请选择查询条件！')
            this.ID = this.inquireList.number01
            params.append("ID", this.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('159753' + params)
            const { data: res } = await this.$http.get('/WMS/VariableValueRecord', { params })
            console.log(res.data)
            this.init(res.data)
        }
    }
}
</script>

<style lang="less" scoped>
.echart01 {
  width: 50%;
  height: 90%;
}
.from01 {
  display: flex;
}
.bytn01 {
  margin-left: 3%;
}
</style>
